export default __webpack_public_path__ + "static/media/bg_tablet_food.c86588d8.jpg";